import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;

const WidgetsService = {
  getHomeWidgets: async (widgetPageType, isOnshore = true) => {
    const response = await apiService.get("/intelligent-portal/home-widgets", {
      params: {
        widgetPageType,
        isOnshore: String(isOnshore),
      },
    });

    return response.data;
  },
};

export default WidgetsService;
